'use strict';

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getHistory } from '@/history';

export default () => {

	const history = getHistory();

	return (
		<div onClick={ () => history.back() }>
			<FontAwesomeIcon icon='arrow-left' color='#444' />
		</div>
	);
};
